// 商铺首页
import * as React from "react";
import * as ReactDOM from "react-dom";
import "../../components/common";
import "./en.css";

import Header from "./common/header/index";
import RequirementsForm from "./common/requirements-form/index";
import Socialize from './common/socialize/index'
import Chat from './common/chat/index'
import config from "../../utils/config";
import request from "../../utils/request";
import { pushPath, getShopInfo } from "../../utils/utils";
import "../../components/shop/common";

export default class Store extends React.Component < {}, any > {
    constructor(props: any) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
            bannerList: [],
            goodList: {
                tab: [],
                goods: [],
            }, // 商品数据
            id: "", // 企业id
            shopId: "", // 店铺id
            shopDomain: "", // 店铺域名
            shopInfo: {}, // 店铺信息
            modelsId: "", // 模板id
            styleConfig: {},
            isMiniBaiduProgram: (window as any).isMiniBaiduProgram, // 是否在百度小程序中
        };
    }
    public componentDidMount() {
        this.receiveShopInfo();
        this._getBanner();
    }

    public render() {
        const that = this;
        const { styleConfig, shopInfo } = this.state;

        return (
            <div>
        <Header shopInfo={shopInfo} />
        {this.state.bannerList.length > 0 &&
          this.state.bannerList.map((bv: any, bk: number) => {
            return bv ? (
              bv.type < 3 ? (
                <div className="focus" key={`swiperItem${bk}`}>
                  <div className="banner">
                    <div
                      className={`swiper-container goods-banner swiper${bk}`}
                    >
                      <div className="swiper-wrapper">
                        {bv.banner_info.map(function (v: any, k: number) {
                          return (
                            <div
                              className="swiper-slide"
                              key={`banner-info-item-${k}`}
                            >
                              <a href={v.banner_url}>
                                <img src={v.banner_img} alt="" />
                              </a>
                            </div>
                          );
                        })}
                      </div>
                      <div
                        className={`swiper-pagination swiper-pagination${bk}`}
                      >
                        {bv.banner_info && bv.banner_info.length > 1
                          ? bv.banner_info.map(function (v: any, k: number) {
                              return (
                                <span
                                  className={`swiper-pagination-bullet ${k === 0 ? "" : "swiper-pagination-bullet-active"}`}
                                  key={`swiperPagination${k}`}
                                ></span>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                this._renderAd(bk, bv)
              )
            ) : null;
          })}

        {this.state.bannerList.length === 0 && styleConfig.wap_top_banner && (
          <div className="focus">
            <div
              className="banner"
              style={{ display: styleConfig.wap_top_banner ? "block" : "none" }}
            >
              <img src={styleConfig.wap_top_banner} alt="" />
            </div>
          </div>
        )}
        <div className="all column-box">
          <div className="newtitle">
            <h4>Products Featured</h4>
            <span>
              <a
                href="javascript: void(0);"
                onClick={() => pushPath("/offerlist", "")}
              >
                view all &gt;
              </a>
            </span>
          </div>
          <div>
            <div className="list">
              {this.state.goodList.tab.map(function (v: any) {
                return that.renderGoodsItem(v);
              })}
              {this.state.goodList.goods.map(function (v: any, k: number) {
                return that.renderGoodsItem(v);
              })}
            </div>
          </div>
        </div>
        <RequirementsForm />
        <Socialize shopInfo={shopInfo} />
        <Chat />
      </div>
        );
    }

    /**
     * [renderGoodsItem 渲染商品列表]
     * @param  {[any]} v [商品项]
     * @return {[jsx]}   [结构]
     */
    private renderGoodsItem(v: any) {
        return (
            <div className="card" key={v.goods_id}>
        <a onClick={() => pushPath("/offer", `?id=${v.goods_id}`)}>
          <img
            src={v.img_src}
            alt=""
            style={{
              height: (this.state.windowWidth - 4) * 0.94 * 0.485 + "px",
            }}
          />
          <p className="text1" title={v.goods_name}>{v.goods_name}</p>
          <p className="text2">$Inquiry</p>
        </a>
      </div>
        );
    }

    // 获取企业id
    private async receiveShopInfo() {
        const r = await getShopInfo({ lanType: 1 })

        this.setState({
                id: r.company_id || "",
                shopId: r.shop_id || "",
                modelsId: this.getQueryString("modelsId") || r.models_id,
                shopDomain: r.shop_domain || "",
                shopInfo: r,
            },
            () => {
                this._getStyle();
                this._getGoods();
            },
        );
    }

    // 获取商品数据
    private async _getGoods() {
        const path: any = (window as any).shopId;

        const r = await request({
            data: {
                typeId: 4,
                portType: 2,
                shopDomain: path,
                lanType: 1,
            },
            method: "post",
            url: `${config.PHPAPI}api/wshop/goods/tag-goods`,
        });

        if (r.error_code === 0) {
            this.setState({
                goodList: r.data,
            });
        }
    }

    // 渲染魔方
    private _renderModel(data: any) {
        let template = "";

        switch (`${data.modelId}`) {
            case "0":
                template =
                    '<div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px" data-index="1"><a href="' +
                    (data.img[0] ? data.img[0].link : "") +
                    '"><img src="' +
                    (data.img[0] ? data.img[0].url : "") +
                    '"  alt="" /></a></div>';
                break;
            case "1":
                template =
                    '<div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px" data-index="1"><a href="' +
                    (data.img[0] ? data.img[0].link : "") +
                    '"><img src="' +
                    (data.img[0] ? data.img[0].url : "") +
                    '"  alt="" /></a></div><div class="layout-item" data-index="2"><a href="' +
                    (data.img[1] ? data.img[1].link : "") +
                    '"><img src="' +
                    (data.img[1] ? data.img[1].url : "") +
                    '"  alt="" /></a></div>';
                break;
            case "2":
                template =
                    '<div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="1"><a href="' +
                    (data.img[0] ? data.img[0].link : "") +
                    '"><img src="' +
                    (data.img[0] ? data.img[0].url : "") +
                    '"  alt="" /></a></div><div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="2"><a href="' +
                    (data.img[1] ? data.img[1].link : "") +
                    '"><img src="' +
                    (data.img[1] ? data.img[1].url : "") +
                    '"  alt="" /></a></div><div class="layout-item" data-index="3"><a href="' +
                    (data.img[2] ? data.img[2].link : "") +
                    '"><img src="' +
                    (data.img[2] ? data.img[2].url : "") +
                    '"  alt="" /></a></div>';
                break;
            case "3":
                template =
                    '<div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="1"><a href="' +
                    (data.img[0] ? data.img[0].link : "") +
                    '"><img src="' +
                    (data.img[0] ? data.img[0].url : "") +
                    '"  alt="" /></a></div><div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="2"><a href="' +
                    (data.img[1] ? data.img[1].link : "") +
                    '"><img src="' +
                    (data.img[1] ? data.img[1].url : "") +
                    '"  alt="" /></a></div><div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="3"><a href="' +
                    (data.img[2] ? data.img[2].link : "") +
                    '"><img src="' +
                    (data.img[2] ? data.img[2].url : "") +
                    '"  alt="" /></a></div><div class="layout-item" data-index="4"><a href="' +
                    (data.img[3] ? data.img[3].link : "") +
                    '"><img src="' +
                    (data.img[3] ? data.img[3].url : "") +
                    '"  alt="" /></a></div>';
                break;
            case "4":
                template =
                    '<div class="layout-box" style="min-width: 100%; height: 50%; display: flex; padding-bottom: ' +
                    parseInt(data.range, 10) / 4 +
                    'px "> <div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="1"><a href="' +
                    (data.img[0] ? data.img[0].link : "") +
                    '"><img src="' +
                    (data.img[0] ? data.img[0].url : "") +
                    '"  alt="" /></a></div> <div class="layout-item"  data-index="2"><a href="' +
                    (data.img[1] ? data.img[1].link : "") +
                    '"><img src="' +
                    (data.img[1] ? data.img[1].url : "") +
                    '"  alt="" /></a></div> </div> <div class="layout-box" style="min-width: 100%; height: 50%; display: flex; padding-top: ' +
                    parseInt(data.range, 10) / 4 +
                    'px"> <div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) +
                    'px " data-index="3"><a href="' +
                    (data.img[2] ? data.img[2].link : "") +
                    '"><img src="' +
                    (data.img[2] ? data.img[2].url : "") +
                    '"  alt="" /></a></div> <div class="layout-item"  data-index="4"><a href="' +
                    (data.img[3] ? data.img[3].link : "") +
                    '"><img src="' +
                    (data.img[3] ? data.img[3].url : "") +
                    '"  alt="" /></a></div> </div>';
                break;
            case "5":
                template =
                    '<div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="1"><a href="' +
                    (data.img[0] ? data.img[0].link : "") +
                    '"><img src="' +
                    (data.img[0] ? data.img[0].url : "") +
                    '"  alt="" /></a></div> <div class="layout-box " style="display: flex; flex: 1; flex-direction: column;"> <div class="layout-item" style="min-width: 100%; height: 50%; display: flex; margin-bottom: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="2"><a href="' +
                    (data.img[1] ? data.img[1].link : "") +
                    '"><img src="' +
                    (data.img[1] ? data.img[1].url : "") +
                    '"  alt="" /></a></div> <div class="layout-item" style="min-width: 100%; height: 50%; display: flex; " data-index="3"><a href="' +
                    (data.img[2] ? data.img[2].link : "") +
                    '"><img src="' +
                    (data.img[2] ? data.img[2].url : "") +
                    '"  alt="" /></a></div> </div>';
                break;
            case "6":
                template =
                    '<div class="layout-box" style="width: 100%; height: 100%;"><div class="layout-item" style="height: 50%; display: flex; padding-bottom: ' +
                    parseInt(data.range, 10) / 2 +
                    'px " data-index="1"><a href="' +
                    (data.img[0] ? data.img[0].link : "") +
                    '"><img src="' +
                    (data.img[0] ? data.img[0].url : "") +
                    '"  alt="" /></a></div><div class="layout-box" data-index="2" style="height: 50%; display: flex; flex: 1;"> <div class="layout-item" data-index="2" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px  "><a href="' +
                    (data.img[1] ? data.img[1].link : "") +
                    '"><img src="' +
                    (data.img[1] ? data.img[1].url : "") +
                    '"  alt="" /></a></div><div class="layout-item" data-index="3" style=""><a href="' +
                    (data.img[2] ? data.img[2].link : "") +
                    '"><img src="' +
                    (data.img[2] ? data.img[2].url : "") +
                    '"  alt="" /></a></div></div>';
                break;
            case "7":
                template =
                    '<div class="layout-item" style="margin-right: ' +
                    parseInt(data.range, 10) / 2 +
                    'px" data-index="1"><a href="' +
                    (data.img[0] ? data.img[0].link : "") +
                    '"><img src="' +
                    (data.img[0] ? data.img[0].url : "") +
                    '"  alt="" /></a></div><div class="layout-box" style="display: flex; flex: 1; flex-direction: column;"> <div class="layout-item" data-index="2" style="height: 50%; display: flex; margin-bottom: ' +
                    parseInt(data.range, 10) / 4 +
                    'px "><a href="' +
                    (data.img[1] ? data.img[1].link : "") +
                    '"><img src="' +
                    (data.img[1] ? data.img[1].url : "") +
                    '"  alt="" /></a></div> <div class="layout-box"  style="height: 50%; display: flex;"><div class="layout-item" data-index="3" style="margin-right: ' +
                    parseInt(data.range, 10) / 4 +
                    'px"><a href="' +
                    (data.img[2] ? data.img[2].link : "") +
                    '"><img src="' +
                    (data.img[2] ? data.img[2].url : "") +
                    '"  alt="" /></a></div><div class="layout-item" data-index="4"><a href="' +
                    (data.img[3] ? data.img[3].link : "") +
                    '"><img src="' +
                    (data.img[3] ? data.img[3].url : "") +
                    '"  alt="" /></a></div></div></div>';
                break;
        }

        return template;
    }

    // 获取广告位数据
    private async _getBanner() {
        const path: any = (window as any).shopId;

        const r = request({
            data: {
                shopDomain: path,
                lanType: 1,
            },
            method: "post",
            url: config.PHPAPI + "api/wshop/shop/special",
        });

        r.then((res) => {
            if (res.error_code === 0) {
                this.setState({
                        bannerList: res.data && res.data[0] && res.data[0].banner_sys_id === '10' ? res.data.slice(1) : res.data,
                    },
                    () => {
                        const swiperArr: any[] = [];
                        this.state.bannerList.forEach((v: any, k: number) => {
                            if (v.banner_info.length > 1) {
                                swiperArr[k] = new(window as any).Swiper(`.swiper${k}`, {
                                    autoplay: true,
                                    init: true,
                                    loop: true,
                                    pagination: {
                                        el: `.swiper-pagination${k}`,
                                    },
                                });
                            }
                        });
                    },
                );
            }
        });
    }
    private _renderAd(bk: number, bv: any) {
        if (Number(bv.type) === 3 || Number(bv.type) === 4) {
            return bv ?
                bv.banner_info.map(function(v: any, k: number) {
                    return (
                        <div
                dangerouslySetInnerHTML={{
                  __html:
                    Number(bv.type) === 3 ? v.rich_content : v.html_content,
                }}
                key={`specialHtmlItem${k}`}
              />
                    );
                }) :
                null;
        } else if (Number(bv.type) === 5) {
            return (
                <div className="warrper" style={{ display: "block" }}>
          {bv.banner_info[0] && bv.banner_info[0].mofang
            ? bv.banner_info[0].mofang.map((cv: any, ck: number) => {
                return (
                  <div
                    className="model-box"
                    style={{ height: `${cv.imgHeight}px` }}
                    key={`magic-Cube-${bk}${ck}`}
                    dangerouslySetInnerHTML={{ __html: this._renderModel(cv) }}
                  />
                );
              })
            : null}
        </div>
            );
        }
    }
    // 获取样式
    private async _getStyle() {
        const r = request({
            url: config.PHPAPI + "api/wshop/shop/get-models",
            method: "post",
            data: {
                shopId: this.state.shopId,
                shopDomain: this.state.shopDomain,
                modelsId: this.state.modelsId,
            },
        });

        r.then((res) => {
            if (res.error_code === 0) {
                this.setState({
                    styleConfig: res.data.wap_configuration,
                });
            }
        });
    }

    private getQueryString(name: string) {
        const reg = new RegExp("(^|/?|&)" + name + "=([^&]*)(&|$)", "i");
        const r = decodeURIComponent(location.href).substr(1).match(reg);
        if (r != null) {
            return r[2];
        }
        return null;
    }
}

ReactDOM.render(<Store />, document.getElementById("root") as HTMLElement);


// WEBPACK FOOTER //
// ./src/containers/shop_en/index.tsx